import { PrimariaApi } from "@uxland/primary-shell";
import { LitElement, css, html, unsafeCSS } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { lazyInject } from "../../../../infrastructure/ioc/container";
import { TYPES } from "../../../../infrastructure/ioc/types";
import { connectedProperty } from "../../../../infrastructure/state/connected-property";
import { customFilterGroupsWithOptionsSelector } from "../../../selectors";
import { activityHistoryCommonFiltersSelector } from "../../common-filters/selectors";
import { SetCommonFilter } from "../../common-filters/set-common-filter/request";
import { SetCustomFilterAllValues } from "../../custom-filters/set-custom-filter-all-values/request";
import { SetCustomFilterGroup } from "../../custom-filters/set-custom-filter-group/request";
import { SetCustomFilterValue } from "../../custom-filters/set-custom-filter-value/request";
import { IActivityHistoryCommonFilter, IActivityHistoryCustomFilterGroup, IActivityHistoryUpFilter } from "../../model";
import { upFilterEnabledValuesSelector, upFilterSelector } from "../../up-filters/selectors";
import { SetUpFiltersCommand } from "../../up-filters/set/request";
import styles from "./styles.css?inline";
import { template } from "./template";

//@ts-ignore
@customElement("activity-history-filters")
export class ActivityHistoryFilters extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
    ${unsafeCSS(styles)}
  `;

  @connectedProperty(activityHistoryCommonFiltersSelector)
  commonFilters: IActivityHistoryCommonFilter[];

  @connectedProperty(customFilterGroupsWithOptionsSelector)
  customFilterGroups: IActivityHistoryCustomFilterGroup[];

  @connectedProperty(upFilterSelector)
  upFilter: IActivityHistoryUpFilter;

  @connectedProperty(upFilterEnabledValuesSelector)
  upFilterEnabledValues: string[];

  @lazyInject(TYPES.primaryApi)
  api: PrimariaApi;

  @state()
  filtersExpanded = false;

  @property({ type: Boolean })
  wrapperMaximized: boolean;

  updated(changedProperties) {
    if (changedProperties.has("wrapperMaximized")) {
      this.filtersExpanded = this.wrapperMaximized;
    }
  }

  _toggleFilters() {
    this.filtersExpanded = !this.filtersExpanded;
  }

  _onChangeCommonFilterValue(filterId: string, value: boolean) {
    this.api.broker.send(new SetCommonFilter({ id: filterId, enabled: value }));
  }

  _onChangeCustomFilterGroupValue(filterGroupId: string, value: boolean) {
    this.api.broker.send(new SetCustomFilterGroup({ id: filterGroupId, enabled: value }));
  }

  _onChangeCustomFilterValue(filterGroupId: string, filterId: string, optionId: string, value: boolean) {
    this.api.broker.send(
      new SetCustomFilterValue({
        filterGroupId,
        filterId,
        optionId,
        enabled: value,
      }),
    );
  }

  _onChangeCustomFilterAllValues(filterGroupId: string, filterId: string, values: string[]) {
    this.api.broker.send(
      new SetCustomFilterAllValues({
        filterGroupId,
        filterId,
        values: values,
      }),
    );
  }

  _handleUpFilterChange(e: CustomEvent) {
    const selectedValues = e.detail.selectedValue;
    this.api.broker.send(new SetUpFiltersCommand(selectedValues));
  }
}
